<template>
	<div class="main main-really-raised w-50 ml-auto mr-auto">
   <div class="container">
	 <div class="row">
	   <div class="col-12">
								   <div class="controls-header d-flex justify-content-between">
								   <h4 class="card-title mb-3">
											   {{ $t("message.contracts."+document_type) }}
									   </h4>
									   <div class="btns d-flex" style="gap: 10px">
										   <button class="btn btn-sm btn-outline-secondary" @click.prevent="backToContractDocs()"><i class="el-icon-arrow-left"></i> {{ $t("message.back") }}</button>
										   <button type="button" class="btn btn-sm btn-outline-secondary" @click.prevent="downloadXml()"> {{ $t("message.export_xml") }}           
											   <svg
												   width="18"
												   height="18"
												   viewBox="0 0 24 24"
												   fill="none"
												   xmlns="http://www.w3.org/2000/svg"
											   >
												   <path
												   fill-rule="evenodd"
												   clip-rule="evenodd"
												   d="M12 2C12.5523 2 13 2.44772 13 3L13 12.5858L16.2929 9.29289C16.6834 8.90237 17.3166 8.90237 17.7071 9.29289C18.0976 9.68342 18.0976 10.3166 17.7071 10.7071L12.7071 15.7071C12.5196 15.8946 12.2652 16 12 16C11.7348 16 11.4804 15.8946 11.2929 15.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289C6.68342 8.90237 7.31658 8.90237 7.70711 9.29289L11 12.5858L11 3C11 2.44772 11.4477 2 12 2ZM3 14C3.55228 14 4 14.4477 4 15L4 19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20L19 20C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19L20 15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15L22 19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22L5 22C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19L2 15C2 14.4477 2.44772 14 3 14Z"
												   fill="#333"
												   />
											   </svg>
										   </button>
										   <pdf
											   :document="offer"
											   :goods="[]"
											   :user_id="0"
											   :doc_id="document_id"
											   :doc_additional="{}"
											   :source="document_type"
											   :label="$t('message.export_pdf')"
										   ></pdf>
										   <!-- <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'form_m_' + document_id + '.pdf'">
											   <template v-slot="pdfProps">
												   <pdf-form-m :pdfProps="pdfProps" :documentId="document_id"/>
											   </template>
										   </js-pdf> -->
								   </div>
							   </div>
		 <div :class="document_type == 'form_m'?'no-shadow mt-0':'card no-shadow mt-0'">
												   <div :class="document_type == 'form_m'?'':'card-body mt-3'">
													   <form-m v-if="document_type == 'form_m'" 
													   :contract_details="contract_details"
													   :document_id="document_id"
													   :is_new="document_id=='new'"
													   :document_parent="document_parent"
													   :document="{}"
													   />
													   <form-invoice
														   v-if="document_type == 'invoice'"
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
													   ></form-invoice>
													   <form-cmr
														   v-if="
																   document_type == 'cmr'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-cmr>
												   <form-fm1
														   v-if="
																   document_type == 'fm1'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-fm1>
												   <form-epi
														   v-if="
																   document_type == 'epi'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-epi>
												   <form-awb
														   v-if="
																   document_type == 'awb'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-awb>
												   <form-rwb
														   v-if="
																   document_type == 'rwb'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-rwb>
												   <form-insurance
														   v-if="
																   document_type == 'insurance'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-insurance>
												   <form-liability-insurance
														   v-if="
																   document_type == 'liability-insurance'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-liability-insurance>
												   <form-packaging
														   v-if="
																   document_type == 'packaging'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-packaging>

												   <form-sad
														   :files="files"
														   v-if="
																   document_type == 'sad'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-sad>
												   <form-ktg-attorney
														   v-if="
																   document_type == 'ktg_attorney'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
												   ></form-ktg-attorney>

												   <form-specification
														   v-if="
																   document_type == 'specification'
														   "
														   :goods="goods"
														   :contract_details="contract_details"
														   :document_id="document_id"
														   :document="{}"
														   :files="files"
												   ></form-specification>
												   </div>
										   </div>
								   </div>
						   </div>
				   </div>
		   </div>
</template>
<script>
   var FileSaver = require("file-saver");
   import FormM from './../form-m'
   import FormPackaging from './../../contracts/form-packaging.vue'
   export default{
	   name: "InlineDocumentViewer",
	   components: { FormM, FormPackaging },
	   data(){
		   return {
			   document_type: '',
			   document_id: '',
			   document_parent: '',
			   contract_details: {}
		   }
	   },
	   mounted(){
		   if(!this.$route.params.type || this.$route.params.type==''){
			   // this.$router.go(-1)
			   console.log(this.$route.params)
		   }else{
			   this.document_type = this.$route.params.type
			   this.document_id = this.$route.params.id
			   this.document_parent = this.$route.params.parent

			   this.loadContractDetails()
		   }
	   },
	   methods: {
		   /**
			   * proceeds back to contract documents tab
			   */
		   backToContractDocs(){
			   this.$router.push({
				   name: 'contracts-single-documents-tab',
				   params: {
					   id: this.document_parent
				   }
			   })
		   },
		   /**
			   * loads contract details to fill data into the document vie contract details prop
			   */
		   loadContractDetails(){
			   axios.get(window.base + '/document/getFirm').then(response=>{
				   this.owner_company = response.data.org_name
			   })
			   
			   axios.get(window.base + '/Contract/GetContract?attis_contract_id='+this.document_parent)
			   .then(response=>{

				   this.contract_details.attis_contract_id=response.data.attis_contract_id
				   this.contract_details.attis_contract_owner=response.data.attis_contract_owner
				   // this.findLibValue(this.statuses, response.data.attis_contract_status, 'attis_contract_status')
				   this.contract_details.attis_contract_type=response.data.attis_contract_type
				   this.contract_details.attis_contract_case=response.data.attis_contract_case
				   this.contract_details.attis_contract_subject=response.data.attis_contract_subject
				   this.contract_details.attis_contract_desc=response.data.attis_contract_desc
				   this.contract_details.attis_contract_kpveds=response.data.attis_contract_kpveds
				   // this.contract_details.attis_contract_kpveds = '44,482,1422'
				   // this.findLibValue('currency', response.data.attis_contract_currency,'attis_contract_currency')
				   // this.findLibValue('delivery_term', response.data.attis_contract_delivery_term,'attis_contract_delivery_term')
				   this.contract_details.attis_contract_delivery_place=response.data.attis_contract_delivery_place.replace('%2C',',')
				   this.contract_details.attis_contract_date=response.data.attis_contract_date
				   // this.findLibValue('payment_type', response.data.attis_contract_payment_type, 'attis_contract_payment_type')
				   // this.findLibValue('company', response.data.attis_contract_contragent, 'attis_contract_contragent')

				   // setTimeout(()=>{
				   // 	axios.get(window.base + '/document/getFirmbyBin?bin='+this.contract_details.attis_contract_contragent.value).then(response=>{
				   // 		this.counterparty_name = response.data.persons.given_name + ' ' +response.data.persons.middle_name + ' ' + response.data.persons.last_name
				   // 	})
				   // }, 1000)

				   this.contract_details.attis_contract_deadline=response.data.attis_contract_deadline
				   this.contract_details.attis_contract_create_date=response.data.attis_contract_create_date
				   this.contract_details.attis_contract_is_public=response.data.attis_contract_is_public

				   this.attis_contract_goods = response.data.product
				   // this.processProducts()
				   this.files = response.data.files
			   })
		   },
		   /**
			   * finds library value object in array of data by value
			   * @param {*} lib 
			   * @param {*} value 
			   * @param {*} field 
			   */
		   findLibValue(lib, value, field){
			   if(typeof lib == 'string'){
				   axios.get(window.base+'/library?type='+lib+'&query=&qty=1000'+'&lang='+this.$i18n.locale)
				   .then(response=>{
					   response.data.forEach(item=>{
						   if(item.value.trim().toLowerCase()==value.trim().toLowerCase()){
							   this.$set(this.attis_contracts,field, item)
						   }
					   })
				   })
			   }else{
				   lib.forEach(item=>{
					   if(item.value == value)
						   this.$set(this.attis_contracts, field, item)
				   })
			   }
		   },
		   /**
			   * process products
			   */
		   processProducts(){
			   if(typeof this.attis_contract_goods !== 'undefined')
				   this.attis_contract_goods.forEach((item, index)=>{
					   // this.findTNVED(item.attis_cg_TNVED, index)
					   // if (item.attis_cg_measures)
					   // 	this.findLibValueProduct('measure', item.attis_cg_measures, 'attis_cg_measures', index)
				   })
		   },
		   downloadXml() {
			   var endpoint = "";
			   console.log(this.document_type);
			   switch (this.document_type.toLowerCase()) {
				   case "fm1":
					   endpoint = `/document/LoadFm1Xml?id=${this.document_id}`;
					   break;
				   case "cmr":
					   endpoint = `/document/LoadCMRXML?doc_id=${this.document_id}`;
					   break;
				   case "packaging":
					   endpoint = `/document/getPackingListXML?doc_id=${this.document_id}`;
				   case "epi":
					   endpoint = `/document/LoadEpiXML?id=${this.document_id}`;
					   break;
				   case "invoice":
					   endpoint = `/document/LoadInvoiceXML?doc_id=${this.document_id}`;
				   default:
					   break;
			   }

			   axios.get(`${window.base}${endpoint}`).then((response) => {
				   var blob = new Blob([response.data], { type: "text/xml" });
				   FileSaver.saveAs(blob, `${this.document_type}.xml`);
				   });
			   }
	   }
   }
</script>
<style>
   .dropdown-menu {
	   transform: translate3d(-55px, 34px, 0px)!important;
   }
</style>